(() => {
  // Bundler renders its own labels after Liquid and can replace them on selection.
  // This adapter changes display text only, never App state or form attributes.
  if (window._gjlOptionLabels) return;
  window._gjlOptionLabels = true;

  const selector = 'product-info form[data-type="add-to-cart-form"] .bndlr-variant-label';
  const colorNames = new Set(['颜色', '顏色', 'color', 'colour']);

  function normalize(label) {
    if (!label.matches(selector) || label.childElementCount) return;
    const text = label.textContent;
    if (text !== 'Color' && colorNames.has(text.trim().toLowerCase())) {
      label.textContent = 'Color';
    }
  }

  function scan(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) normalize(node);
    node.querySelectorAll(selector).forEach(normalize);
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      const parent = record.target.nodeType === Node.TEXT_NODE
        ? record.target.parentElement : record.target;
      if (parent instanceof Element && parent.matches(selector)) normalize(parent);
      record.addedNodes.forEach(scan);
    });
  });

  scan(document.documentElement);
  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
